<template>
  <v-container
    fill-height
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        xs="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
      >
        <v-alert
          v-if="error"
          color="error"
          outlined
          class="alert-login-failed"
        >
          <p v-for="(msgError, index) in error" :key="index" class="ma-0">
            {{ msgError }}
          </p>
        </v-alert>

        <v-card
          class="elevation-12 pa-5"
        >
          <v-form
            ref="form_login"
            @submit="entrar"
            v-on:submit.prevent="() => false"
          >
            <v-card-text class="text-center">
              <img
                src="../assets/logo-empresta.svg"
                class="logo-empresta"
                alt="Empresta Bem Melhor"
                title="Empresta Bem Melhor"
              >
              <div><h6 class="title font-weight-regular">Faça seu login</h6></div>
            </v-card-text>

            <v-card-text class="pl-0 pr-0">
              <v-text-field
                v-model="cpf"
                name="cpf"
                id="cpf"
                label="CPF"
                :placeholder="chrome ? ' ' : ''"
                type="tel"
                v-mask="'###.###.###-##'"
                :rules="[v => !!v || 'CPF é obrigatório']"
                required
              ></v-text-field>

              <v-text-field
                v-model="senha"
                hide-details="auto"
                name="senha"
                id="senha"
                label="Senha"
                :placeholder="chrome ? ' ' : ''"
                :rules="[v => !!v || 'Senha é obrigatório']"
                required
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-card-text>

            <v-card-actions class="pl-0 pr-0 mt-4">
              <v-btn
                block
                large
                color="primary"
                type="submit"
              >Entrar</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <Loading :exibir="loading" />
    <AlterarDadosPessoais @closed="irParaIntranet()" v-model="alterar" :showEmail.sync="showEmail" :showPhone.sync="showPhone">
    </AlterarDadosPessoais>
  </v-container>
</template>

<script>
import Loading from '../components/Loading'
import AlterarDadosPessoais from '../components/AlterarDadosPessoais'
import { v4 as uuid } from 'uuid';

const https = require('https');
var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
const urlRedirect = urlParams.get('url_redirect') ? urlParams.get('url_redirect') : '';
const pathRedirect = urlParams.get('path_redirect') ? urlParams.get('path_redirect').split('/')[1] : '';
console.log(urlRedirect + '--' + pathRedirect);

export default {
  name: 'Login',
  components: {
    Loading,
    AlterarDadosPessoais
  },
  data: () => ({
    cpf: '',
    senha: '',
    showPassword: false,
    showEmail: false,
    showPhone: false,
    error: false,
    alterar: false,
    loading: false,
    chrome: false,
    site:false,
    geolocalizacao: null
  }),
  methods: {
    async entrar() {
      const valido = this.$refs.form_login.validate()
      if(!valido) {
        return false
      }
      const dadosDispositivo = await this.armanezarDadosDispositivo()
      console.log('dadosDispositivo: ', {
        cpf: `${this.cpf}`.replace(/[^0-9]/g, ''),
        senha: this.senha,
        site: this.site,
        urlRedirect: urlRedirect,
        dados_dispositivo: dadosDispositivo ? dadosDispositivo : null
        //ip: ip.ip
      })

      // const ip = await this.buscarIpPublic()
      this.loading = true
      this.axios.post('login', {
        cpf: `${this.cpf}`.replace(/[^0-9]/g, ''),
        senha: this.senha,
        site: this.site,
        urlRedirect: urlRedirect,
        dados_dispositivo: dadosDispositivo ? dadosDispositivo : null,
        //ip: ip.ip
      }, {
        headers: {Authorization:''}
      }).then(response => {
        const { status } = response
        const { data } = response

        if( (status < 200 || status > 299) || !data.access_token ) {
          return this.error = 'Erro de comunicação com servidor!'
        }

        this.setStorage('token', data.access_token)
        this.setStorage('redirect', data.redirect)
        this.setStorage('pathRedirect', pathRedirect)
        if(data.redirect_busca_ip){
          this.setStorage('redirect_busca_ip', data.redirect_busca_ip)
        }
        if(data.redefinir_senha) {
          this.setStorage('redefinir_senha', data.redefinir_senha)
          return this.$router.push({name: 'alterar-senha'})
        }

        const {redefinir_dados_pessoais} = data
        if(
          redefinir_dados_pessoais &&
          (redefinir_dados_pessoais.phone || redefinir_dados_pessoais.email)
        ){
          this.setStorage('redefinir_dados_pessoais', redefinir_dados_pessoais);
          this.alterar = true;
          this.showPhone = redefinir_dados_pessoais.phone
          this.showEmail = redefinir_dados_pessoais.email
          return;
        }

        this.armazenarAcesso().then(() => {
          this.irParaIntranet()
        })
      }).catch((err) => {
        this.loading = false
        let {data} = err.response.data
        if(data) {
          data = Array.isArray(data) ? data : Object.values(data)
        }
        this.error = data || ['Erro de comunicação com servidor!']
      })
    },
    irParaIntranet() {
      const token = this.getStorage('token')
      let redirect = this.getStorage('redirect')
      let path = this.getStorage('pathRedirect')
      let redirectBuscaIp = this.getStorage('redirect_busca_ip')

      if(token && redirect) {
        if(redirectBuscaIp){
          return window.location.href = `${redirectBuscaIp}?token=${token}&redirect=${redirect}`
        }else if (path) {
          redirect = `${redirect}?token=${token}&redirect=${path}`
          return window.location.href = redirect
        } else {
          redirect = `${redirect}?token=${token}`
          return window.location.href = redirect
        }
      }

      this.removerLocalStorage()
      window.location.reload()
    },
    async validarToken() {
      const token = this.getStorage('token')
      if(!token) {
        this.removerLocalStorage()
        return false
      }

      return await this.axios.get('validar-token', {
        headers: {Authorization: `Bearer ${token}`}
      })
        .then(() => true)
        .catch(() => {
          this.removerLocalStorage()
          return this.error = ['Sua sessão expirou. Por favor, realize o login novamente.']
        })

    },
    async irParaSistema() {
      const token = this.getStorage('token')
      const {base} = this.$route.query

      if(!base) {
        return this.irParaIntranet()
      }

      await this.axios.post('usuario/validar-acesso', {
        base, headers: {Authorization: `Bearer ${token}`}
      }).then(response => {
        const { data } = response.data
        const { status } = response

        if(!data.autorizado || status !== 200) {
          return false
        }
        const token = this.getStorage('token')
        window.location.href=`${data.redirect}?token=${token}`
      }).catch(() => this.irParaIntranet())
    },
    async obterInformacoesDoDispositivo() {
      const userAgent = navigator.userAgent;
      const mobile = /Mobi/i.test(userAgent);

      let navegador = "Desconhecido";

      if (/Firefox/i.test(userAgent)) {
        navegador = "Firefox";
      } else if (/Chrome/i.test(userAgent)) {
        navegador = "Chrome";
      } else if (/Safari/i.test(userAgent)) {
        navegador = "Safari";
      } else if (/Edge/i.test(userAgent)) {
        navegador = "Edge";
      } else if (/IE/i.test(userAgent)) {
        navegador = "Internet Explorer";
      }

      let sistema_operacional = 'Desconhecido'

      if (/Windows/i.test(userAgent)) {
        sistema_operacional=  "Windows";
      } else if (/Macintosh|Mac OS X/i.test(userAgent)) {
        sistema_operacional=  "macOS";
      } else if (/Linux/i.test(userAgent)) {
        sistema_operacional=  "Linux";
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        sistema_operacional=  "iOS";
      } else if (/Android/i.test(userAgent)) {
        sistema_operacional=  "Android";
      }

      return {
        ...this.geolocalizacao,
        mobile: mobile ? 'S' : 'N',
        navegador,
        sistema_operacional
      };
    },
    async armanezarDadosDispositivo() {
      let token = await this.obterCookie("token_dispositivo");
      
      const dados_dispositivo = await this.obterInformacoesDoDispositivo();

      if (!token) {
        let novoToken = uuid();
        let dataDeExpiracao = new Date();
        dataDeExpiracao.setFullYear(dataDeExpiracao.getFullYear() + 1);

        document.cookie = "token_dispositivo=" + novoToken + "; expires=" + dataDeExpiracao.toUTCString();
        token = novoToken;
      }

      return {
          ...dados_dispositivo,
          token,
          ultimo_login_dispositivo:  btoa(Date.now())
        }
    },
    async obterCookie(nome) {
      let cookies = document.cookie.split('; ');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].split('=');
        if (cookie[0] === nome) {
          return cookie[1];
        }
      }
      return null;
    },
    // async buscarIpPublic() {
    //   return await this.axios.get(`https://api.ipify.org/?format=json`)
    //   .then(async response => {
    //     return response.data
    //   })
    //   .catch(() => {
    //   })
    // },
    async buscarIp() {
      return this.axios.get(`${process.env.VUE_APP_BASE_URI_API_ASTERISK}buscaIpLocal.php`,
        {
          httpsAgent: new https.Agent({
            rejectUnauthorized: false
          })
        }
      )
      .then(async response => {
        const { status } = response
        const { ip } = response.data

        return { valido: ([200, 201].includes(status)), ip }
      })
      .catch(() => {
        console.log('Erro ao buscar IP!')
        return { valido: false }
      })
    },
    async armazenarAcesso() {
      const token = this.getStorage('token')
      // const dados = await this.buscarIp()
      const dados = { valido: true, ip: null }
// 

      return await this.axios.post('usuario/armazenar-acesso', {
        ip: dados.valido ? dados.ip : null,
      }, {
        headers: {Authorization: `Bearer ${token}`}
      })
      .then(() => true)
      .catch(() => {
        console.log('Erro ao armazenar acesso!')
      })

    },
    removerLocalStorage() {
      localStorage.removeItem('token')
      localStorage.removeItem('redirect')
      localStorage.removeItem('redefinir_senha')
    },
    getStorage(key) {
      return localStorage.getItem(key)
    },
    setStorage(key, value) {
      localStorage.setItem(key, value)
    }
  },
  async created() {
    this.loading = true
    this.site = window.location.href.split("/").pop() == '?my_variable=true' ? true : false;
    const tokenValido = await this.validarToken()
    const redefinirSenha = localStorage.getItem('redefinir_senha')
    const redefinirDadosPessoais= localStorage.getItem('redefinir_dados_pessoais');
    if(!tokenValido) {
      this.removerLocalStorage()
    }

    navigator.geolocation.getCurrentPosition((position) => {
      this.geolocalizacao = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      };
    });

    if(navigator.userAgent.indexOf('Chrome') > -1) {
      this.chrome = true
    }

    if(redefinirSenha) {
      return this.$router.push({name: 'alterar-senha'})
    }

    if(tokenValido === true) {
      return this.irParaSistema()
    }
    if(redefinirDadosPessoais && (redefinirDadosPessoais.phone ||
        redefinirDadosPessoais.email)){
          this.alterar=true;
          this.showPhone=redefinirDadosPessoais.phone
          this.showEmail=redefinirDadosPessoais.email
          return;
    }

    const novaUrl = window.location.href.split('?')
    if(novaUrl.length == 2 && novaUrl!='?my_variable=true') {
      this.$router.push({name: 'login'})
    }

    setTimeout(() => this.error = '', 10000)
    return this.loading = false
  }
}
</script>

<style scoped lang="scss">
.logo-empresta {
  height:65px;
  margin-bottom:10px
}
</style>
